export default "__VITE_ASSET__DETjxCa___"